import { OZON_SERVICE_NAME } from '#shared/lib/brand';
import { getOzonOauthCookieDomain, getOzonRedirectStaticUri, OZON_OAUTH_STORAGE_KEY } from '#shared/lib/const';
import { showSuccess } from '#shared/lib/toast';
import { getOzonOauthUrl } from '#shared/lib/url';
import { integrationOzonCredentialsGet, integrationOzonOauth } from '../api';
import { useOauthPopupConnect } from './useOauthPopupConnect';

type UseOzonOauthConnectParams = {
    onSuccess: () => Promise<unknown>;
};

export function useOzonOauthConnectIntegration({ onSuccess }: UseOzonOauthConnectParams) {
    const { isConnecting, handleConnect } = useOauthPopupConnect({
        cookieKey: OZON_OAUTH_STORAGE_KEY,
        serviceName: OZON_SERVICE_NAME,
        getCredentials: integrationOzonCredentialsGet,
        buildUrl: getOzonOauthUrl,
        getCookieDomain: getOzonOauthCookieDomain,
        onCookieSuccess: async ({ code, state }) => {
            await integrationOzonOauth({
                authorization_code: code,
                redirect_uri: getOzonRedirectStaticUri(),
                state_token: state,
            });

            await onSuccess();
            showSuccess(`Источник ${OZON_SERVICE_NAME} успешно подключен`);
        },
    });

    return { isConnecting, handleConnect };
}
